import { HttpClient, provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { APP_ID, APP_INITIALIZER, ApplicationConfig, importProvidersFrom } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideClientHydration, withNoHttpTransferCache } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AddressService } from './_service/AddressService';
import { authInterceptor } from './_service/AuthInterceptor';
import { AuthService } from './_service/AuthService';
import { BoxService } from './_service/BoxService';
import { CmsService } from './_service/CmsService';
import { DeliverydayService } from './_service/DeliverydayService';
import { DrawerService } from './_service/DrawerService';
import { FaqService } from './_service/FaqService';
import { LifestyleService } from './_service/LifestyleService';
import { LinkService } from './_service/LinkService';
import { PricingService } from './_service/PricingService';
import { ProductService } from './_service/ProductService';
import { RecipeService } from './_service/RecipeService';
import { StaticpageService } from './_service/StaticpageService';
import { WINDOW_PROVIDERS } from './_service/WindowService';
import { AppRoutingModule, routes } from './appModule/app-routing.module';
import { LogoutResolver } from './appModule/logout/logout.resolver';
import { LocalizedDatePipe } from './sharedModule/pipe/localizedDate.pipe';
import { SharedModule } from './sharedModule/shared.module';
import { MissingTranslationHandler, MissingTranslationHandlerParams, TranslateCompiler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MESSAGE_FORMAT_CONFIG, TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';
import { environment } from './_environments/environment';
import { CntrcService } from './_service/CntrcService';
import { GlobalService } from './_service/GlobalService';
import { TaxonomyService } from './_service/TaxonomyService';


export function createTranslateLoader(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}

export class TranslateHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {

    if (!environment.production) {
      console.log('*** Missing translations for:', params.translateService.currentLang, "'" + params.key + "'");
    }
    return params.key; // here u can return translation
  }
}

export const appConfig: ApplicationConfig = {
  providers: [

    provideHttpClient(
      withFetch(),
      withInterceptors([authInterceptor]),
    ),
    provideRouter(routes),
    provideClientHydration(),
    importProvidersFrom(
      // BrowserModule.withServerTransition({ appId: 'serverApp' }),
      AppRoutingModule,
      SharedModule,
      ReactiveFormsModule,
      FormsModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient]
        },
        compiler: {
          provide: TranslateCompiler,
          useClass: TranslateMessageFormatCompiler
        },
        isolate: false,
        missingTranslationHandler: [{ provide: MissingTranslationHandler, useClass: TranslateHandler }]
      })
    ),
    {
      provide: MESSAGE_FORMAT_CONFIG,
      useValue: {
        // locales: ['nl', 'en'],
        biDiSupport: false,
        disablePluralKeyChecks: false,
        formatters: undefined,
        locales: undefined,
        strictNumberSign: false
      }
    },
    { provide: APP_ID, useValue: 'serverApp' },
    // { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },

    AddressService,
    AuthService,
    
    BoxService,
    CmsService,
    CookieService,

    DrawerService,
    DeliverydayService,

    FaqService,
    FormBuilder,
    GlobalService,

    LifestyleService,
    LinkService,
    LocalizedDatePipe,
    LogoutResolver,

    ProductService,
    PricingService,

    RecipeService,
    StaticpageService,
    TaxonomyService,

    WINDOW_PROVIDERS,
    CntrcService,
    {
      provide: APP_INITIALIZER,
      useFactory: (cntrc: CntrcService) => () => cntrc.init(),
      deps: [CntrcService],
      multi: true,
    },
    provideAnimations(),
  ]
};
